<div class="wrap">
  <app-section-header-gap></app-section-header-gap>
  <div class="wrap__container">
    <div class="container">
      <h1 class="container__title">お探しのページが見つかりませんでした</h1>
      <p class="container__text">絵本の中に答えを見つけに行く冒険の旅はいかがですか？</p>
      <div class="container__buttons">
        <app-button
          (buttonClick)="onHomeButtonClick()"
          [fullWidth]="true"
        >ホーム</app-button>
        <app-button
          (buttonClick)="onBooksButtonClick()"
          [fullWidth]="true"
          color="accent-alt"
        >絵本を見る</app-button>
      </div>
    </div>
  </div>
  <!-- center alignment compenstaion -->
  <app-section-header-gap></app-section-header-gap>
</div>
